/**
 * Bedrock model id conventions for Business Value.
 *
 * Usage events store the exact inference profile id from usage_capture
 * (get_effective_bedrock_model_id), e.g. us.anthropic.claude-sonnet-4-5-20250929-v1:0.
 * Per-model pricing keys must match that string exactly for cost overrides to apply.
 */

export function normalizeBedrockModelId(modelId) {
  return (modelId || '').trim();
}

/** Chart / table label — friendly name only; full id stays in tooltips. */
export function formatBedrockModelDisplayName(modelId) {
  const m = normalizeBedrockModelId(modelId).toLowerCase();
  if (!m || m === 'unknown') return 'Unknown model';
  if (m.includes('claude-sonnet-4-5') || m.includes('sonnet-4-5')) return 'Claude Sonnet 4.5';
  if (m.includes('claude-sonnet-4') || m.includes('sonnet-4-')) return 'Claude Sonnet 4';
  if (m.includes('claude-opus')) return 'Claude Opus';
  if (m.includes('claude-haiku')) return 'Claude Haiku';
  const raw = normalizeBedrockModelId(modelId);
  const tail = raw.includes('.') ? raw.split('.').pop() : raw;
  return tail.length > 32 ? `${tail.slice(0, 30)}…` : tail;
}

export function isLikelyBedrockModelId(modelId) {
  const m = normalizeBedrockModelId(modelId);
  if (m.length < 12) return false;
  return m.includes('.') || m.startsWith('anthropic.') || m.startsWith('us.');
}

export const BEDROCK_MODEL_ID_HINT =
  'Use the exact Bedrock model id from LLM usage (hover “LLM cost by model” bars or pick from the dropdown). Example: us.anthropic.claude-sonnet-4-5-20250929-v1:0';
